var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7831 22.6172H35.3423C35.9194 22.6172 36.3905 23.0881 36.3905 23.6651V33.4992C36.3905 34.5883 35.5072 35.4714 34.4178 35.4714H13.5899C12.5005 35.4714 11.6172 34.5883 11.6172 33.4992V23.7828C11.6172 23.1382 12.1413 22.6172 12.7831 22.6172Z",
    stroke: "#0F2A59",
    strokeWidth: 1.63822,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7969 22.554V19.8843C13.7969 19.4839 14.056 19.1602 14.3769 19.1602H33.6179C33.9388 19.1602 34.1979 19.4839 34.1979 19.8843V22.554",
    stroke: "#0F2A59",
    strokeWidth: 1.63822,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5068 19.1931C33.0327 16.8236 29.7233 16.6587 26.4876 16.4968C24.6857 16.4056 22.9073 16.3173 21.7914 15.8493C20.8051 15.4342 20.3634 14.6483 21.0082 13.1118C21.1584 12.7557 20.811 12.4172 20.44 12.5614C18.4467 13.365 17.0187 14.3628 16.0736 15.5225C15.1844 16.6146 14.7222 17.845 14.625 19.1901",
    stroke: "#0F2A59",
    strokeWidth: 1.63822,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsNew);
export default __webpack_public_path__ + "static/media/products-new.1b3c713470058980b64ebd500a55547f.svg";
export { ForwardRef as ReactComponent };